var _g, _circle, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchconfirm2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bii_2110_273770)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.660492 15.4696C-0.220163 13.941 -0.220164 12.059 0.660491 10.5304L5.29982 2.47756C6.18294 0.944662 7.81739 9.32214e-08 9.58647 1.14318e-07L18.8467 2.24745e-07C20.6158 2.45841e-07 22.2503 0.944662 23.1334 2.47756L27.7727 10.5304C28.6534 12.059 28.6534 13.941 27.7727 15.4696L23.1334 23.5224C22.2503 25.0553 20.6158 26 18.8467 26L9.58647 26C7.81739 26 6.18294 25.0553 5.29982 23.5224L0.660492 15.4696Z",
    fill: "#19191E"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.2668,
    cy: 12.246,
    r: 4.99039,
    fill: "#E9BE5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3881 15.2988C19.1396 14.0636 19.4125 12.5958 19.1549 11.173C18.8974 9.75024 18.1273 8.47119 16.9905 7.5778C15.8536 6.68441 14.4288 6.23864 12.9854 6.32482C11.5421 6.41099 10.1804 7.02312 9.15794 8.04543C8.13641 9.06812 7.52494 10.4296 7.43914 11.8726C7.35334 13.3155 7.79915 14.7399 8.69228 15.8764C9.58542 17.013 10.864 17.7829 12.2863 18.0407C13.7086 18.2985 15.1761 18.0263 16.4113 17.2756L18.4121 19.2763C18.6742 19.5385 19.0298 19.6858 19.4005 19.6858C19.7712 19.6858 20.1268 19.5385 20.3889 19.2763C20.6511 19.0142 20.7984 18.6587 20.7984 18.2879C20.7984 17.9172 20.6511 17.5616 20.3889 17.2995L18.3881 15.2988ZM9.93351 15.6288C9.4865 15.1818 9.13191 14.6511 8.88998 14.0671C8.64806 13.483 8.52355 12.8571 8.52355 12.2249C8.52355 11.5927 8.64806 10.9668 8.88998 10.3827C9.13191 9.79867 9.4865 9.268 9.93351 8.82099C10.8363 7.91822 12.0607 7.41105 13.3374 7.41105C14.6141 7.41105 15.8386 7.91822 16.7413 8.82099C17.6441 9.72377 18.1513 10.9482 18.1513 12.2249C18.1513 13.5016 17.6441 14.726 16.7413 15.6288C14.8644 17.5057 11.8104 17.5057 9.93351 15.6288ZM19.6133 18.5008C19.5564 18.5563 19.48 18.5873 19.4005 18.5873C19.321 18.5873 19.2446 18.5563 19.1877 18.5008L17.2987 16.6119C17.3729 16.5447 17.4456 16.4756 17.5169 16.4044C17.5881 16.3332 17.6573 16.2604 17.7244 16.1862L19.6133 18.0751C19.6692 18.1319 19.7004 18.2083 19.7004 18.2879C19.7004 18.3676 19.6692 18.444 19.6133 18.5008Z",
    fill: "#E9BE5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9676 10.7953C15.9401 10.7288 15.8997 10.6683 15.8488 10.6174C15.7978 10.5665 15.7374 10.5261 15.6708 10.4985C15.6043 10.471 15.533 10.4568 15.461 10.4568C15.3889 10.4568 15.3176 10.471 15.2511 10.4986C15.1845 10.5261 15.1241 10.5665 15.0732 10.6175L12.8496 12.8411L11.6599 11.6513C11.557 11.5485 11.4175 11.4907 11.2721 11.4907C11.1266 11.4907 10.9871 11.5485 10.8843 11.6513C10.7814 11.7542 10.7236 11.8937 10.7236 12.0391C10.7236 12.1846 10.7814 12.3241 10.8843 12.4269L12.4617 14.0044C12.5127 14.0554 12.5731 14.0958 12.6397 14.1233C12.7062 14.1509 12.7775 14.1651 12.8495 14.1651C12.9216 14.1651 12.9929 14.1509 13.0594 14.1233C13.126 14.0958 13.1864 14.0554 13.2373 14.0044L15.8488 11.393C15.8997 11.3421 15.9401 11.2816 15.9676 11.2151C15.9952 11.1486 16.0094 11.0772 16.0094 11.0052C16.0094 10.9332 15.9952 10.8619 15.9676 10.7953Z",
    fill: "#19191E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bii_2110_273770",
    x: -2.35461,
    y: -2.35461,
    width: 33.1423,
    height: 30.7092,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.17731
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2110_273770"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2110_273770",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.362248
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.181124
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2110_273770"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.07911
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_2110_273770",
    result: "effect3_innerShadow_2110_273770"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchconfirm2);
export default __webpack_public_path__ + "static/media/searchconfirm2.ca3a8036aa1911d7492e171b261e464c.svg";
export { ForwardRef as ReactComponent };